import revive_payload_client_4sVQNw7RlN from "/vercel/path0/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/vercel/path0/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/vercel/path0/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "/vercel/path0/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/vercel/path0/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_LcKgStRyi6 from "/vercel/path0/node_modules/nuxt-gtag/dist/runtime/plugin.client.mjs";
import templates_pwa_client_15bedddc_j9xTpfLwQp from "/vercel/path0/.nuxt/templates.pwa.client.15bedddc.ts";
import composition_sLxaNGmlSL from "/vercel/path0/node_modules/@nuxtjs/i18n/dist/runtime/plugins/composition.mjs";
import i18n_yfWm7jX06p from "/vercel/path0/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import chunk_reload_client_UciE0i6zes from "/vercel/path0/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import toast_ysMjUcU7eJ from "/vercel/path0/plugins/toast.ts";
import global_2XP5sjpyNs from "/vercel/path0/plugins/global.ts";
import scrollbar_ebQvq1qiBz from "/vercel/path0/plugins/scrollbar.ts";
import lottie_q1asFBKAuo from "/vercel/path0/plugins/lottie.ts";
import dragscroll_U3dCpB8oXl from "/vercel/path0/plugins/dragscroll.ts";
import auto_animate_uTpJuTGsMC from "/vercel/path0/plugins/auto-animate.ts";
import sentry_3AyO8nEfhE from "/vercel/path0/plugins/sentry.ts";
import openlayers_WWBSgWfy3k from "/vercel/path0/plugins/openlayers.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_LcKgStRyi6,
  templates_pwa_client_15bedddc_j9xTpfLwQp,
  composition_sLxaNGmlSL,
  i18n_yfWm7jX06p,
  chunk_reload_client_UciE0i6zes,
  toast_ysMjUcU7eJ,
  global_2XP5sjpyNs,
  scrollbar_ebQvq1qiBz,
  lottie_q1asFBKAuo,
  dragscroll_U3dCpB8oXl,
  auto_animate_uTpJuTGsMC,
  sentry_3AyO8nEfhE,
  openlayers_WWBSgWfy3k
]